/* eslint-disable no-console */
import { Injectable, ErrorHandler, inject } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { NotifyService } from "./notify.service";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root"
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private ns = inject(NotifyService);

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      console.group("HttpErrorResponse");
      if (!navigator.onLine) {
        this._logError("No Internet Connection! Cannot invoke " + error.url);
      } else {
        this._logError("Invoked url: ", error.url);
      }
      this._logError("Backend returned status code: ", error.status);
      this._logError("Response body:", error.message);
      this._logError("Full HttpErrorResponse:", error);
      console.groupEnd();
    } else {
      console.group("Error");
      this._logError(error.message);
      this._logError(error.stack);
      console.groupEnd();
    }

    // this._sendError(error)

    if (!environment.production) {
      if (this.ns.isOpen) {
        return;
      }
      this.ns.applicationError("OOPS! Something went wrong . . . . . . . . . " + error.name + " : " + error.message);
    }
  }

  /**
   * @param message
   * @param opts
   */
  private _logError(message: string, ...opts: any[]) {
    const errDate = new Date();
    console.error("[" + errDate.toLocaleString() + "] " + message, opts);
  }

  // private _sendError(error: Error | HttpErrorResponse | any) {
  // TODO: Send http
  // console.log('url', error.url);
  // console.log('status', error.status, error.statusText)
  // console.log('message', error.message)
  // console.log('date', new Date())
  // console.log('env', this.authService.environment.description)
  // console.log('user', this.authService.credentials.username)
  // }
}
